<template>
  <div class="problem">
    <div class="topTitle">
      <span @click="goback">返回</span> / 新增比赛
    </div>
    <div class="mian">
      <div>

        <el-button type="primary" @click="add" icon="el-icon-plus" size="mini">添加问题</el-button>
        <!-- <el-button type="primary" @click="addmack" icon="el-icon-plus" size="mini">MarkDown添加问题</el-button> -->

        <el-button type="primary" @click="addList" size="mini">题库导入</el-button>
        <el-button type="primary" icon="el-icon-delete" size="mini" @click="dels">批量删除</el-button>

      </div>
      <el-table :data="tableData" size="mini" stripe style="width: 100%;margin-top: 20px;"
        :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange1">
        <el-table-column type="selection">
        </el-table-column>
        <el-table-column prop="sort_num" label="排序号">
        </el-table-column>
        <el-table-column prop="problemInfo.code" label="比赛题号">
        </el-table-column>
        <el-table-column prop="problemInfo.title" label="问题名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="problemInfo.created_time" label="创建时间">
        </el-table-column>

        <el-table-column label="是否可见">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.problemInfo.visible" active-color="#409EFF" inactive-color="#ccc"
              @change="changeType(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="显示类型">
          <template slot-scope="scope">
            <span v-if="scope.row.problemInfo.description_show_type === 1">富文本</span>
            <span v-if="scope.row.problemInfo.description_show_type === 2">MarkDown</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editSortNum(scope.row)">更新排序号</el-button>
            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" v-if="scope.row.is_public === true"
              @click="isPublic(scope.row)">取消</el-button>
            <el-button type="text" size="mini" v-else @click="isPublic1(scope.row)">转为公共</el-button>
            <el-button type="text" size="mini" @click="del(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加题目" :visible.sync="dialogVisible" width="80%">
      <el-form ref="form" :model="form" :inline="true" size="mini">
        <el-form-item label="标题">
          <el-input v-model="form.title" clearable placeholder="请输入标题"
            @keyup.enter.native="adminGetOjProblemListGame"></el-input>
        </el-form-item>
        <el-form-item label="题目编号">
          <el-input v-model="form.code" clearable placeholder="请输入题目编号"
            @keyup.enter.native="adminGetOjProblemListGame"></el-input>
        </el-form-item>
        <el-form-item label="按知识点筛选">
          <el-cascader @change="changeKonw" style="width: 230px;" v-model="form.Know" :props="Konwprops"
            :options="KnowledgeList" collapse-tags clearable></el-cascader>
        </el-form-item>
        <el-form-item label="按难度筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.conditions" placeholder="请选择" clearable>
            <el-option v-for="item in conditionList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按来源筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.source" placeholder="请选择" clearable>
            <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="adminGetOjProblemListGame" icon="el-icon-search" size="mini">查询</el-button>

        </el-form-item>
      </el-form>
      <el-table ref="ListTable" :data="tableData1" :row-key="(row) => { return row.id }" size="mini" stripe
        style="width: 100%;margin-top:20px" :header-cell-style="{ background: '#f5f7fa' }"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="code" label="题号">
        </el-table-column>
        <el-table-column prop="title" label="标题">
        </el-table-column>
        <el-table-column label="标签">
          <template slot-scope="scope">
            <span v-for="item in scope.row.problemTagArr" :key="item.id">
              {{ item.tagInfo.title }},
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="difficultyTitle" label="难度">
        </el-table-column>
        <el-table-column prop="sourceTitle" label="来源">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1"
          layout="total, prev, pager, next, jumper" :total="total1">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 更新排序号 -->
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="20%">
      <el-form ref="form1" :model="form1" label-width="" :rules="rules" :inline="true" size="mini">
        <el-form-item prop="sort_num" label="排序号">
          <el-input-number v-model="form1.sort_num" :precision="2" :step="0.01"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="adminUpdateContestProblemSortNum">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>

import {
  adminGetOjProblemListGame,
  adminAddProblemForContest,
  adminGetProblemForContest,
  adminDeleteProblemForContest,
  adminUpdateOjProblemPublic,
  adminUpdateOjProblemVisible,
  adminUpdateContestProblemSortNum,
  getOjProblemDifficultyList,//按难度筛选
  getOjProblemTagGroupList,//知识点
  getOjProblemSourceList,//来源
}
  from "@/api/adminOj.js";
// import {
//   getOjProblemDifficultyList,//按难度筛选
//   getOjProblemTagGroupList,//知识点
//   getOjProblemSourceList,//来源
// }
//   from "@/api/educational.js"
export default {
  data() {
    return {
      //来源
      sourceList: [],
      //知识点
      KnowledgeList: [],
      Konwprops: {
        value: 'id',
        label: 'title',
        children: 'tagArrInfo',
        multiple: true
      },
      //难度
      conditionList: [],
      contest_problem_realtion_id: '',
      form1: {
        sort_num: 0,
        conditions: [],
        Know: [],
        source: [],
        Know1: [],
      },
      page_no: 1,
      page_size: 20,
      total: 20,
      form: {},
      gameId: '',
      multipleSelection: [],
      multipleSelection1: [],
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      dialogVisible: false,
      dialogVisible1: false,
      tableData1: [],
      tableData: [

      ],
      rules: {
        sort_num: [
          {
            required: true,
            message: "请输入排序号",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入排序号",
            trigger: "blur",
          },
        ],
      },
    }
  },
  created() {
    this.gameId = JSON.parse(this.$route.query.row).id
  },
  mounted() {
    this.adminGetProblemForContest()
    this.getOjProblemDifficultyList()//按难度筛选
    this.getOjProblemTagGroupList()//知识点
    this.getOjProblemSourceList()//来源

  },
  methods: {
    //查询
    //难度
    getOjProblemDifficultyList() {
      getOjProblemDifficultyList({}).then((res) => {
        this.conditionList = res.ojProblemDifficultyList
      })
    },
    //知识点
    getOjProblemTagGroupList() {
      getOjProblemTagGroupList().then((res) => {
        this.KnowledgeList = res.ojProblemTagGroupList
        console.log(res, 5653232);
      })
    },
    changeKonw(val) {
      this.form.Know1 = []
      val.map((item) => {
        this.form.Know1.push(item[1])
      })
      console.log(this.form.Know1, 452121);
    },
    //来源
    // sourceList
    getOjProblemSourceList() {
      getOjProblemSourceList({}).then((res) => {
        console.log(res)
        this.sourceList = res.ojProblemSourceList
      })
    },
    editSortNum(row) {
      this.dialogVisible1 = true
      this.contest_problem_realtion_id = row.id
      this.form1.sort_num = row.sort_num


    },
    adminUpdateContestProblemSortNum() {
      adminUpdateContestProblemSortNum({
        contest_problem_realtion_id: this.contest_problem_realtion_id,
        sort_num: this.form1.sort_num
      }).then((res) => {
        console.log(res)
        this.$message.success('修改成功!')
        this.dialogVisible1 = false
        this.adminGetProblemForContest()


      })

    },
    changeType(val) {
      val.visible != val.visible
      console.log(val.visible)

      let visible1 = ''
      if (val.visible === true) {
        visible1 = '1'
      }
      if (val.visible === false) {
        visible1 = '0'
      }
      adminUpdateOjProblemVisible({
        id: val.id,
        visible: visible1
      }).then((res) => {
        console.log(res)
        this.$message.success('更新成功！')
        this.adminGetProblemForContest()

      })

    },

    isPublic(val) {

      adminUpdateOjProblemPublic({
        id: val.id,
        is_public: '0'
      }).then((res) => {
        console.log(res)
        this.$message.success('更新成功！')
        this.adminGetProblemForContest()
      })

    },
    isPublic1(val) {

      adminUpdateOjProblemPublic({
        id: val.id,
        is_public: '1'
      }).then((res) => {
        console.log(res)
        this.$message.success('更新成功！')
        this.adminGetProblemForContest()
      })

    },
    handleSelectionChange1(val) {
      console.log(val)
      let arr = []
      this.multipleSelection1 = [];
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].oj_problem_id);
        console.log(arr)
        this.multipleSelection1 = arr
      }
      console.log(this.multipleSelection1)


    },
    dels() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning('请选中再进行删除!')
        return false
      }
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteProblemForContest({
          contest_id: this.gameId,
          problemIds: JSON.stringify(this.multipleSelection1)
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.adminGetProblemForContest()

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });



    },
    del(row) {
      console.log(row.id)
      let ids = []
      ids.push(row.oj_problem_id)
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteProblemForContest({
          contest_id: this.gameId,
          problemIds: JSON.stringify(ids)
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.adminGetProblemForContest()


        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    adminGetProblemForContest() {
      adminGetProblemForContest({
        constest_id: this.gameId,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 123465798)
        this.tableData = res.contestProblemRelationList
        this.total = res.total
      })
    },
    submit() {
      adminAddProblemForContest({
        contest_id: this.gameId,
        problemIds: JSON.stringify(this.multipleSelection)
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功!!')
        this.dialogVisible = false
        this.adminGetProblemForContest()

      })
    },
    handleSelectionChange(val) {
      console.log(val)
      let arr = []
      this.multipleSelection = [];
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id);
        console.log(arr)
        this.multipleSelection = arr
      }
      console.log(this.multipleSelection)


    },
    add() {
      sessionStorage.setItem('isMarkDown1', '1')

      this.$router.push({
        name: 'addSubject',
        query: {
          contest_id: this.gameId,
          type: 'Game',
          addType: '1'

        }
      })
    },
    // addmack() {
    //   sessionStorage.setItem('isMarkDown1', '1')
    //   this.$router.push({
    //     name: "addSubject",
    //     query: {
    //       contest_id: this.gameId,
    //       type: 'Game',
    //       addType: '2'

    //     }
    //   });
    // },
    goback() {
      this.$router.go(-1)
    },
    addList() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.ListTable.clearSelection()
      })
      this.page_no1 = 1
      this.adminGetOjProblemListGame()

    },
    adminGetOjProblemListGame() {
      adminGetOjProblemListGame({
        // ...this.form,
        code: this.form.code,
        difficultyIdArr: JSON.stringify(this.form.conditions),
        tagIdArr: JSON.stringify(this.form.Know1),
        sourceIdArr: JSON.stringify(this.form.source),
        title_code: this.form.title_code,
        contest_id: this.gameId,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res)
        this.tableData1 = res.ojProblemList
        this.total1 = res.total

      })
    },
    handleCurrent1(val) {
      this.page_no1 = val
      this.adminGetOjProblemListGame()

    },
    handleCurrent(val) {
      this.page_no = val
      this.adminGetProblemForContest()

    },
    edit(row) {
      console.log(row, 1451212);
      sessionStorage.setItem('isMarkDown1', row.problemInfo.description_show_type)
      this.$router.push({
        name: "addSubject",
        query: {
          row: row.oj_problem_id,
          type: 'Game',

        }

      });
    }
  }

}
</script>
<style lang="scss" scoped>
.problem {
  height: 100%;
  width: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  cursor: pointer;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.mian {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
</style>